<template>
<div class="start">
  <div class="nav">
    <div class="logo"><img src="/assets/images/logo-navbar.svg"></div>
    <div class="button-home" @click="goLanguage('nl')"><img :src="'/assets/buttons/button-home.svg'"></div>
  </div>
  <div class="start-container">
    <div class="start-item" @click="goLanguage('nl')">
      <img src="/assets/buttons/badge-start-page.svg" alt="Start">
    </div>
  </div>
</div>
</template>

<script>
import router from '@/router';
export default {
    name: 'Start',
    methods: {
        goLanguage(langIn) {
            router.push('/spots/' + langIn);
        }
    }
}
</script>

<style>
.start {
    position: absolute;
    left: 0;
    top: 0;
    background-color: #67808A;
    width: 100%;
    height: fit-content;
    min-height: 100%;
}
.start-container {
    position: relative;
    margin-top: 60px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 5%;
    width: 100%;
}

.start-item {
    width: 55%;
    padding-top: 30%;
    padding-bottom: 2%;
    padding-left: 2%;
    padding-right: 2%;
    margin-left: auto;
    margin-right: auto;
  align-items: center;
}

.start-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>
